import React from "react";
import { useSelector } from "react-redux";
import { PermissionsKey } from "../../data/permissions";
import { RootState } from "../../redux/store";
import { useTranslation } from "react-i18next";

type Props = {
  children: React.ReactNode;
  permissions?: PermissionsKey[];
  isPage?: boolean;
  onlyAdmin?:boolean
};

export function PermissionGate({ permissions = [], children, isPage = false,onlyAdmin=false }: Props) {
  const { t } = useTranslation();

  // Get slices from redux
  const admin = useSelector((s: RootState) => s.admin);
  const store = useSelector((s: RootState) => s.store);
  const owner = useSelector((s: RootState) => s.owner);
  const organizer = useSelector((s: RootState) => s.organizer);


  // Determine role dynamically
  let role: "admin" | "store" | "owner" | "organizer" | null = null;
  if (admin?.accessToken) role = "admin";
  else if (store?.accessToken) role = "store";
  else if (owner?.accessToken) role = "owner";
    else if (organizer?.accessToken) role = "organizer";

  // Store/Owner users see everything
  if ((role === "store" || role === "owner" || role==="organizer") && !onlyAdmin) return <>{children}</>;

  if (!admin) return null;

  // Admin → check permissions
  const hasPermission = permissions.some((p) => admin.permissions.includes(p));

  if (hasPermission) return <>{children}</>;

  // Admin does not have permission
  if (isPage) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-light p-6">
        <div className="bg-white shadow-custom-light rounded-2xl p-10 max-w-md text-center">
          <h1 className="text-3xl font-bold text-danger mb-4">{t("no_permission_title")}</h1>
          <p className="text-gray-600 mb-6">{t("no_permission_message")}</p>
          <button
            onClick={() => window.history.back()}
            className="px-6 py-2 bg-primary text-white rounded-lg hover:bg-primaryButton transition"
          >
            {t("go_back")}
          </button>
        </div>
      </div>
    );
  }

  // Default → render nothing
  return null;
}
